import React from 'react';
import { ReactComponent as CheckIcon } from "assets/img/svg/CheckIcon.svg"
import { Modal, ModalBody } from 'reactstrap';
import AButton from 'views/pages/manage/common/form-fields-mui/AButton';
const ApprovalDialog = ({ isOpen, setOpen, approverData='' }) => {
    const closeHandler = () => {
        setOpen(false)
    }
    return <Modal
        isOpen={isOpen}
        style={{ width: '24%' }}
        size="xl"
        centered={true}
    >
        <ModalBody className='p-4'>
            <div className='d-flex flex-column' style={{gap:'8px'}}>
                <span className=" d-flex align-items-center justify-content-center" style={{ backgroundColor: '#05945B', border: '1px', borderRadius: '50%', width: '56px', height: '56px' }}><CheckIcon /></span>
                <div className='dark-text label-color'>
                    Paymode change request sent
                </div>
                <div className='regular-bold'>
                    Paymode change request has been sent to approver {`${approverData?.username} (${approverData?.employeeId})`}
                </div>
                <div className="mt-3" style={{ marginLeft: '-12px' }}>
                <AButton
                        variant={"primary_filled"}
                        updatedStyle={{ width: '40%' }}
                        disabled={''}
                        onClick={() => {closeHandler() }}
                    >
                        Okay
                    </AButton>
                </div>
            </div>
        </ModalBody>
    </Modal>

}
export default ApprovalDialog